var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagnostic-records"},[_c('div',{staticClass:"diagnostic-records-container"},[_c('div',{staticClass:"diagnostic-records-content"},[_c('div',{staticClass:"record-group"},[_c('h3',{staticClass:"moudleDefaultTitle"},[_vm._v("资质诊断记录")]),_c('diagnostic-records',{attrs:{"matters-type":_vm.mattersType,"more-records":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }